import { Radio } from "@fluentui/react-components";
import { memo, ReactNode } from "react";
import { SearchModeLabel } from "./SearchModeLabel";

type SearchModeRadioProps = {
  label: string;
  tooltipContent: ReactNode;
  searchMode: string;
  selectedMode: string;
  disabledRadioLabel: boolean;
};

export const SearchModeRadio = memo(
  ({ label, tooltipContent, searchMode, disabledRadioLabel, selectedMode }: SearchModeRadioProps) => {
    return (
      <Radio
        value={searchMode}
        disabled={disabledRadioLabel}
        label={
          <SearchModeLabel
            label={label}
            tooltipContent={tooltipContent}
            searchMode={searchMode}
            disabledRadioLabel={disabledRadioLabel}
            selectedMode={selectedMode}
          />
        }
      />
    );
  }
);
